import { useEffect, useState } from "react";

const InputSelect = ({
  label,
  options = [],
  showError = false,
  errorMessage = "Por favor, seleccione una opción",
  onChange = () => { },
  defaultValue = "",
  name = "",
  showNoDataMessage = false,
  noDataMessage = "",
  ...rest
}) => {
  const [selected, setSelected] = useState("");
  const [showErrorAfterClick, setShowErrorAfterClick] = useState(false);

  useEffect(() => {
    if (showNoDataMessage && options.length <= 0) {
      setShowErrorAfterClick(true);
    } else {
      setShowErrorAfterClick(false);
    }

  }, [showNoDataMessage, options]);


  useEffect(() => {
    setSelected(defaultValue);
  }, [defaultValue]);

  const handleOnchange = (e) => {
    setSelected(e.target.value !== "");
    e.target.classList.remove("input-error")
    const label = e.target.nextElementSibling;
    if (label && label.classList.contains("select-nodata-message")) {
      label.classList.remove("label-error");
    }
    onChange(e);
  };

  const handleOnClick = (e) => {
    setShowErrorAfterClick(options.length <= 0);
  }

  return (
    <label className="label-md">
      <select
        className="form-select"
        name={name}
        onClick={handleOnClick}
        onChange={handleOnchange}
        value={defaultValue}
        {...rest}
      >
        <option className="d-none" value=""></option>
        {options.map((option, index) => (
          <option key={option.value + index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <span className={`span-md ${selected !== "" ? "" : "span-active"}`}>
        {label}
      </span>
      {(showError && options.length > 0) && <span className="select-error">{errorMessage}</span>}
      {showErrorAfterClick && <span className="select-nodata-message">{noDataMessage}</span>}
    </label>
  );
};

export default InputSelect;
